// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/index.js
export { default as itemLineNumberColumn } from './itemLineNumberColumn';
export { default as itemValidationColumn } from './itemValidationColumn';
export { default as itemSkuColumn } from './itemSkuColumn';
export { default as itemDescriptionColumn } from './itemDescriptionColumn';
export { default as itemUnitColumn } from './itemUnitColumn';
export { default as itemQuantityColumn } from './itemQuantityColumn';
export { default as itemUnitPriceColumn } from './itemUnitPriceColumn';
export { default as itemDiscountColumn } from './itemDiscountColumn';
export { default as itemTotalColumn } from './itemTotalColumn';
export { default as itemNcmColumn } from './itemNcmColumn';
export { default as itemCfopColumn } from './itemCfopColumn';
export { default as itemCestColumn } from './itemCestColumn';
export { default as itemIbptColumn } from './itemIbptColumn';
export { default as itemIcmsColumn } from './itemIcmsColumn';
export { default as itemIcmsStColumn } from './itemIcmsStColumn';
export { default as itemIpiColumn } from './itemIpiColumn';
export { default as itemPisColumn } from './itemPisColumn';
export { default as itemCofinsColumn } from './itemCofinsColumn';

/**
 * Resolve font size for item columns based on size option.
 * Used by all item column files to support size variants.
 *
 * @param {string} size - 'small' (default) | 'middle'
 * @param {number} defaultSize - base font size for the column type (11 regular, 10 tax)
 * @returns {number} resolved font size
 */
export function resolveItemFontSize(size, defaultSize) {
  if (size === 'middle') return defaultSize <= 10 ? 12 : 14;
  return defaultSize; // 'small' or undefined → keep default
}
